(function () {
  // =====================================================
  // Utils
  // =====================================================

  // Select
  function $(expr, container) {
    return typeof expr === 'string'
      ? (container || document).querySelector(expr)
      : expr || null;
  }

  function $$(expr, container) {
    return Array.prototype.slice.call(
      (container || document).querySelectorAll(expr)
    );
  }

  // Shop info
  const info = JSON.parse(document.getElementById('shop-info').innerHTML) || {};

  const moneyFormat = info.moneyFormat;
  const locale = info.locale;
  const placeholderUrl = info.placeholderUrl;

  // Quantity Selector
  function quantitySelector(selector, cb = () => {}) {
    const $el = typeof selector === 'string' ? $(selector) : selector;
    const $input = $('.js-qtySelector_input', $el);
    const $less = $('.js-qtySelector_less', $el);
    const $more = $('.js-qtySelector_more', $el);

    const price = parseFloat($el.dataset.price);
    const id = parseInt($el.dataset.id, 10);
    const min = parseInt($input.getAttribute('min'), 10) || 0;
    let max = parseInt($input.getAttribute('max'), 10);

    $more.addEventListener('click', update.bind(null, 1));
    $less.addEventListener('click', update.bind(null, -1));
    $input.addEventListener('input', update.bind(null, 0));

    function update(factor) {
      const currentQty = parseInt($input.value, 10);
      const newVal = currentQty + factor;

      if (isNaN(currentQty) || newVal <= min) {
        $input.value = min;
        $less.setAttribute('disabled', true);
        $more.removeAttribute('disabled');
        cb(getState(min));
      } else if (newVal >= max) {
        $input.value = max;
        $more.setAttribute('disabled', true);
        $less.removeAttribute('disabled');
        cb(getState(max));
      } else {
        $less.removeAttribute('disabled');
        $more.removeAttribute('disabled');
        $input.value = newVal;
        cb(getState(newVal));
      }
    }

    function getState(currentQty = null) {
      const quantity = currentQty || parseInt($input.value, 10);
      return { id, price, quantity, totalPrice: price * quantity, max };
    }

    function destroy() {
      $more.removeEventListener('click', update);
      $less.removeEventListener('click', update);
      $input.removeEventListener('input', update);
    }

    function reset() {
      $input.value = min;
      $more.removeAttribute('disabled');
      $less.setAttribute('disabled', true);
      $input.removeAttribute('disabled');
    }

    function disable() {
      $input.setAttribute('disabled', true);
      $more.setAttribute('disabled', true);
      $less.setAttribute('disabled', true);
    }

    function setMax(newMax = null) {
      if (!newMax && newMax !== 0) return;

      if (newMax === 0) {
        disable();
        max = newMax;
        return;
      }

      max = newMax;
      $input.max = newMax;
    }

    return { destroy, reset, getState, disable, setMax, id };
  }

  // Image helpers
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  function getSizedImageUrl(src, size, crop = null) {
    if (src === null) return null;
    if (size === null) return src;

    if (size === 'master') {
      return removeProtocol(src);
    }

    const match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      const c = crop ? `_crop_${crop}` : '';

      return removeProtocol(`${prefix[0]}_${size}${c}${suffix}`);
    }

    return null;
  }

  // Factory
  function factory(fn, el, hide = false) {
    const els = $$(el);
    const instances = [];

    if (!hide && els.length > 0) {
      els.forEach((el) => {
        instances.push(fn(el));
      });
    }

    return instances;
  }

  // Cookies
  function getCookie(name) {
    var v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`;
  }

  function deleteCookie(name) {
    setCookie(name, '', -1);
  }

  // =====================================================
  // Modules
  // =====================================================

  // init
  // =====================================================

  function init() {
    function addClassesIDOnScroll() {
      window.addEventListener('scroll', () => {
        const anchorpoints = document.getElementsByClassName('anchorpoint');

        for (let index = 0; index < anchorpoints.length; index++) {
          const element = anchorpoints[index];

          window.scrollY > element.offsetTop
            ? document.body.classList.add(element.id)
            : document.body.classList.remove(element.id);
        }
      });
    }

    function menuOver() {
      const aboutUsID = 'page-72249901219';

      const wineLiDesktop = document.querySelector(
        ".menu a[href*='/#winegrid_home']"
      );
      const champagneLiDesktop = document.querySelector(
        ".menu a[href*='/#champagne_home']"
      );
      const wineLiMobile = document.querySelector(
        ".menu-mobile a[href*='/#winegrid_home']"
      );
      const champagneLiMobile = document.querySelector(
        ".menu-mobile a[href*='/#champagne_home']"
      );
      const mainElement = document.getElementsByTagName('main');

      if (wineLiMobile) {
        wineLiMobile.addEventListener('click', () => {
          document.body.classList.remove('menu-active');
        });
      }

      if (wineLiDesktop) {
        wineLiDesktop.addEventListener('mouseenter', () => {
          removeAllMenuOverClass();
          document.body.classList.add('wine-menu-active');
        
          champagnes = document.querySelectorAll('header #shopify-section-aspirational-page-grid-lateral .champagne');

          champagnes.forEach((element) => element.classList.add('hidden'));
        
          wines = document.querySelectorAll('header #shopify-section-aspirational-page-grid-lateral .mdm, header #shopify-section-aspirational-page-grid-lateral .pazo');

          wines.forEach((element) => element.classList.remove('hidden'));
        });
      }
 
 	  if (champagneLiDesktop) {
        champagneLiDesktop.addEventListener('mouseenter', () => {
          removeAllMenuOverClass();
          document.body.classList.add('wine-menu-active');
  
          champagnes = document.querySelectorAll('header #shopify-section-aspirational-page-grid-lateral .champagne');

          champagnes.forEach((element) => element.classList.remove('hidden'));
        
          wines = document.querySelectorAll('header #shopify-section-aspirational-page-grid-lateral .mdm, header #shopify-section-aspirational-page-grid-lateral .pazo');

          wines.forEach((element) => element.classList.add('hidden'));
        });
      }

      const menuPagesUl = document.getElementById('menu-pages');

      for (let index = 0; index < menuPagesUl.childNodes.length; index++) {
        const element = menuPagesUl.childNodes[index];

        if (element.id !== aboutUsID) {
          element.addEventListener('mouseenter', () => {
            removeAllMenuOverClass();
          });
        }
      }

      document.addEventListener('click', () => {
        removeAllMenuOverClass();
      });

      mainElement[0].addEventListener('mouseenter', () => {
        removeAllMenuOverClass();
      });

      const menuBurger = document.getElementById('burger');
      if (menuBurger) {
        menuBurger.addEventListener('click', () => {
          document.body.classList.toggle('menu-active');
          document.body.classList.remove('search-active');
        });
      }
    }

    function menuMobile() {
      const aboutUsLi = document.querySelector('a[href*="#about-us-mobile"]');

      if (aboutUsLi) {
        aboutUsLi.addEventListener('click', () => {
          aboutUsLi.parentElement.classList.toggle('open');
        });
      }

      const blogsLi = document.querySelector('a[href*="#blogs-mobile"]');

      if (blogsLi) {
        blogsLi.addEventListener('click', () => {
          blogsLi.parentElement.classList.toggle('open');
        });
      }
    }

    function removeAllMenuOverClass() {
      document.body.classList.remove('wine-menu-active');
    }

    function showHidePassword() {
      const togglePasswordsIcon = document.querySelectorAll('.toggle-password');

      for (let index = 0; index < togglePasswordsIcon.length; index++) {
        const togglePasswordIcon = togglePasswordsIcon[index];
        togglePasswordIcon.addEventListener('click', () => {
          togglePasswordIcon.classList.toggle('active');

          const customerPasswordInput =
            togglePasswordIcon.previousSibling &&
            togglePasswordIcon.previousSibling.previousSibling
              ? togglePasswordIcon.previousSibling.previousSibling
              : undefined;
          if (customerPasswordInput) {
            customerPasswordInput.type === 'password'
              ? (customerPasswordInput.type = 'text')
              : (customerPasswordInput.type = 'password');
          }
        });
      }
    }

    new LazyLoad({
      elements_selector: '.lazy',
    });

    menuOver();
    menuMobile();
    addClassesIDOnScroll();
    showHidePassword();
  }

  // account
  // =====================================================

  function account($el) {
    const HIDDEN = 'hide';
    const ACTIVE = 'is-active';

    const $$links = $$('.js-account_panelLink', $el);
    const $$panels = $$('.js-account_panel', $el);
    const $toggler = $('.js-account_dataToggler', $el);
    const $form = $('.js-account_dataForm', $el);
    // const $$accordion = $$(".js-account_ac", $el);

    new Accordion('.js-account_ac', {
      duration: 200,
      elementClass: 'js-account_acItem',
      triggerClass: 'js-account_acTrigger',
      panelClass: 'js-account_acPanel',
    });

    $toggler.addEventListener('click', () => {
      $form.classList.toggle(HIDDEN);
    });

    if ($$links.length && $$panels.length) {
      $$links.forEach(($link) => {
        $link.addEventListener('click', (e) => {
          e.preventDefault();
          if ($link.classList.contains(ACTIVE)) return;
          const id = $link.href.split('#')[1];

          showPanel(id);
        });
      });
    }

    function showPanel(id) {
      const $newPanel = $(`#tab-${id}`, $el);
      const $link = $(`.js-account_panelLink[href*="#${id}"]`, $el);

      $$links.forEach(($link) => $link.classList.remove(ACTIVE));
      $$panels.forEach(($panel) => $panel.classList.add(HIDDEN));

      $link.classList.add(ACTIVE);
      $newPanel.classList.remove(HIDDEN);
      history.replaceState({}, '', $link.href);
      window.scrollTo(0, 0);
    }

    if (window.location.hash) {
      const hash = window.location.hash.split('#')[1];
      window.location.hash = '';
      showPanel(hash);
    } else {
      showPanel('main');
    }
  }

  // addresses
  // =====================================================

  function addresses($el) {
    const HIDDEN = 'hide';
    const $$addresses = $$('.js-addresses_address', $el);
    const $$forms = $$('.js-addresses_form', $el);

    const $newWrap = $('.js-addresses_newWrap', $el);
    const $newAdd = $('.js-addresses_newAdd', $el);
    const $newCancel = $('.js-addresses_newCancel', $el);

    function showNew() {
      $newWrap.classList.remove(HIDDEN);
      $newAdd.classList.add(HIDDEN);
      focusFirstInput($newWrap);
    }

    function hideNewForm() {
      $newWrap.classList.add(HIDDEN);
      $newAdd.classList.remove(HIDDEN);
    }

    function hideEditForms() {
      if ($$forms.length) {
        $$forms.forEach(($el) => {
          $el.classList.add(HIDDEN);
        });
      }
    }

    function focusFirstInput($parent) {
      const $input = $('input[type=text]', $parent);
      $input.focus();
    }

    $newAdd.addEventListener('click', () => {
      showNew();
      hideEditForms();
    });

    $newCancel.addEventListener('click', hideNewForm);

    if ($$addresses.length) {
      $$addresses.forEach(($el) => {
        const $form = $('.js-addresses_form', $el);
        const $toggler = $('.js-addresses_toggler', $el);
        const $cancel = $('.js-addresses_cancel', $el);
        const $delete = $('.js-addresses_delete', $el);

        $toggler.addEventListener('click', () => {
          if ($form.classList.contains(HIDDEN)) {
            hideEditForms();
            hideNewForm();
            $form.classList.remove(HIDDEN);
            focusFirstInput($form);
          } else {
            $form.classList.add(HIDDEN);
          }
        });

        $cancel.addEventListener('click', () => {
          hideEditForms();
        });

        $delete.addEventListener('submit', (evt) => {
          const msg = evt.target.dataset.confirmMessage;

          if (!window.confirm(msg)) {
            evt.preventDefault();
          }
        });
      });
    }

    if (window.location.hash === '#new') {
      showNew();
    }
  }

  // anchorpoints
  // =====================================================

  function anchorpoints() {
    const $$links = $$('.anchorpoint-section');

    if (!$$links.length) return;

    setOnClickEventAboutUsListeners();

    window.addEventListener('scroll', () => {
      if (window.pageYOffset < 200) {
        setFirstAnchorpoint();
      }
    });

    function setFirstAnchorpoint() {
      resetActiveAnchorpoint();

      if (!$$links[0].classList.contains('active')) {
        $$links[0].classList.add('active');
      }
    }

    function resetActiveAnchorpoint() {
      $$links.forEach(($link) => $link.classList.remove('active'));
    }

    function setOnClickEventAboutUsListeners() {
      $$links.forEach(($link) => {
        $link.addEventListener(
          'click',
          () => {
            resetActiveAnchorpoint();
            $link.classList.add('active');
            const href = $link.dataset['href'];

            if (document.querySelector('#' + href)) {
              document.querySelector('#' + href).scrollIntoView({
                behavior: 'smooth',
              });
            }
          },
          false
        );
      });
    }
  }

  // product
  // =====================================================

  function product(cart) {
    const $el = $('.js-product');
    if (!$el) return;

    const isSingle = $el.dataset.single === 'true';

    const $$qtySelectors = $$('.js-qtySelector');
    const $price = $('.js-product_price');
    const $addSingle = $('.js-product_addSingle');
    const $add = $('.js-product_add');

    const qtys = $$qtySelectors.map(($el) =>
      quantitySelector($el, updatePrice)
    );
    chechMaxQtys();
    initProductHoverListeners();

    if ($add) $add.addEventListener('click', cartAdd);
    if ($addSingle)
      $addSingle.addEventListener('click', cartAdd.bind(null, true));

    function updatePrice({ id, totalPrice, quantity }) {
      if (!isSingle) {
        const total = qtys.reduce((t, qty) => {
          return (t += qty.getState().totalPrice);
        }, 0);
        $price.innerHTML = Shopify.formatMoney(total, moneyFormat);
        return;
      }

      if (quantity === 0) {
        $price.innerHTML = Shopify.formatMoney(0, moneyFormat);
        qtys.forEach((qty) => qty.reset());
      } else {
        $price.innerHTML = Shopify.formatMoney(totalPrice, moneyFormat);
        qtys.filter((qty) => qty.id !== id).forEach((qty) => qty.disable());
      }
    }

    function chechMaxQtys() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((data) => {
          if (!data.items || !data.items.length) return;

          qtys.forEach((qty) => {
            const { id, max } = qty.getState();
            const [item] = data.items.filter((item) => item.id === id);

            if (item) {
              qty.setMax(max - item.quantity);
            }
          });
        });
    }

    function cartAdd(event, isSingle = false) {
      let items = [];

      if (isSingle) {
        items = [
          {
            id: $addSingle.dataset.variantId,
            quantity: 1,
          },
        ];
      } else {
        items = qtys.map((qty) => {
          const { id, quantity } = qty.getState();
          return { id, quantity };
        });
      }

      if (items.length) {
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({ items }),
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(cart.openCart);

        qtys.forEach((qty) => {
          qty.reset();
        });
        chechMaxQtys();
      }
    }

    function initProductHoverListeners() {
      const $$products = $$('.product-hover');
      if (!$$products.length) return;

      $$products.forEach((element) => {
        element.addEventListener('mouseenter', () => {
          const variantID = element.dataset['variantId'];
          const spanImage = document.getElementById(`image_${variantID}`);
          if (!spanImage) return;

          const newImageUrl = spanImage.dataset['variantImage'];
          const image = document.getElementById('product_image');
          image.classList.add('variant');

          if (newImageUrl && image) {
            image.style.backgroundImage = `url('${newImageUrl}')`;
          }
        });

        element.addEventListener('mouseleave', () => {
          const spanImage = document.getElementById(`default_image`);
          const newImageUrl = spanImage.dataset['variantImage'];
          const image = document.getElementById('product_image');
          image.classList.remove('variant');

          if (newImageUrl && image) {
            image.style.backgroundImage = `url('${newImageUrl}')`;
          }
        });
      });
    }
  }

  // accordion
  // =====================================================

  function acc($el) {
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    const showFirst = $el.dataset.showFirst === 'true';
    const $$open = $$($el.dataset.openFirstWith);
    const opts = {
      duration: 200,
      onOpen: (el) => {
        if (!isInViewport(el)) {
          scroll({
            top: el.offsetTop - 72,
            behavior: 'smooth',
          });
        }
      },
    };

    if (showFirst) opts.openOnInit = [0];

    const ac = new Accordion($el, opts);

    if ($$open.length) {
      $$open.forEach(($open) => {
        $open.addEventListener('click', () => {
          ac.open(0);
          setTimeout(() => {
            scroll({
              top: $el.offsetTop - 72,
              behavior: 'smooth',
            });
          }, 200);
        });
      });
    }
  }

  // search
  // =====================================================

  function search() {
    function activeSearchPanel() {
      const main = document.getElementsByTagName('main');
      const searchInput = document.getElementById('search-menu');
      const searchIcon = document.getElementById('search-icon');

      main[0].addEventListener('click', () => {
        document.body.classList.remove('search-active');
      });

      searchIcon.addEventListener('click', () => {
        document.body.classList.toggle('search-active');

        if (document.body.classList.contains('search-active')) {
          document.body.classList.remove('menu-active');
          removeSearchContent();
          searchInput.value = '';
          searchInput.focus();
        }
      });
    }

    function removeSearchContent() {
      const searchContent = document.getElementById('search-content');
      searchContent.innerHTML = '';
    }

    function setSearchContent(results) {
      removeSearchContent();

      const searchContent = document.getElementById('search-content');
      const ulElement = document.createElement('ul');
	  if(results.products.length > 0)
	  {
		products = results.products;
		const liTitle = document.createElement('li');
      	liTitle.innerHTML = `<span>` + window.localization.strings.products + `</span>`;
        ulElement.appendChild(liTitle);
        
        for (let index = 0; index < products.length; index++) {
          const product = products[index];
 
          const title = product.title.replace('<br>', ' ');
          const liElement = document.createElement('li');
          liElement.innerHTML = `<a href="${product.url}">${title}</a>`;
          ulElement.appendChild(liElement);
        }
      }
                         
      if(results.pages.length > 0)
	  {
		pages = results.pages;
		const liTitle = document.createElement('li');
      	liTitle.innerHTML = `<span>` + window.localization.strings.pages + `</span>`;
        ulElement.appendChild(liTitle);
        
        for (let index = 0; index < pages.length; index++) {
          
          const page = pages[index];
          const title = page.title.replace('<br>', ' ');
          const liElement = document.createElement('li');
          liElement.innerHTML = `<a href="${page.url}">${title}</a>`;
          ulElement.appendChild(liElement);
        }
      }
      
      if(results.articles.length > 0)
	  {
		articles = results.articles;
		const liTitle = document.createElement('li');
      	liTitle.innerHTML = `<span>` + window.localization.strings.posts + `</span>`;;
        ulElement.appendChild(liTitle);
        
        for (let index = 0; index < articles.length; index++) {
          
          const article = articles[index];
          const title = article.title.replace('<br>', ' ');
          const liElement = document.createElement('li');
          liElement.innerHTML = `<a href="${article.url}">${title}</a>`;
          ulElement.appendChild(liElement);
        }
      }
      
      if(results.collections.length > 0)
	  {
		collections = results.collections;
		const liTitle = document.createElement('li');
      	liTitle.innerHTML = `<span>` + window.localization.strings.categories + `</span>`;
        ulElement.appendChild(liTitle);
        
        for (let index = 0; index < collections.length; index++) {
          
          const collection = collections[index];
          const title = collection.title.replace('<br>', ' ');
          const liElement = document.createElement('li');
          liElement.innerHTML = `<a href="${collection.url}">${title}</a>`;
          ulElement.appendChild(liElement);
        }
      }

      searchContent.appendChild(ulElement);
    }

    const searchInput = document.getElementById('search-menu');

    activeSearchPanel();

    searchInput.addEventListener('keyup', () => {
      if (searchInput.value && searchInput.value.length > 3) {
        fetch(
          `/search/suggest.json?q=${searchInput.value}&resources[type]=product,page,article,collection&resources[limit]=4&resources[options][unavailable_products]=last`
        )
          .then((response) => response.json())
          .then((suggestions) => {
            const productSuggestions = suggestions.resources.results;

            if (productSuggestions.products.length > 0 || productSuggestions.pages.length > 0 || productSuggestions.articles.length > 0 || productSuggestions.collections.length > 0) {
              setSearchContent(productSuggestions);
            } else {
              removeSearchContent();
            }
          });
      } else {
        removeSearchContent();
      }
    });
  }

  // winetourism
  // =====================================================

  function wineTourism() {
    const disabled = [
      '24/12/2022',
      '26/12/2022',
      '27/12/2022',
      '28/12/2022',
      '29/12/2022',
      '30/12/2022',
      '31/12/2022',
      '06/01/2023',
      '07/01/2023',
      '10/04/2023',
      '01/05/2023',
      '06/06/2023',
      '07/06/2023',
      '08/06/2023',
      '09/06/2023',
      '10/06/2023',
      '12/06/2023',
      '25/07/2023',
      '24/07/2023',
      '26/07/2023',
      '27/07/2023',
      '28/07/2023',
      '29/07/2023',
      '31/07/2023',
      '01/08/2023',
      '02/08/2023',
      '03/08/2023',
      '04/08/2023',
      '05/08/2023',
      '15/08/2023',
      '23/12/2023',
      '26/12/2023',
      '27/12/2023',
      '28/12/2023',
      '29/12/2023',
      '30/12/2023',
    ];
    const disabledMondays = [
      '24/12/2022',
      '26/12/2022',
      '27/12/2022',
      '28/12/2022',
      '29/12/2022',
      '30/12/2022',
      '31/12/2022',
      '06/01/2023',
      '07/01/2023',
      '10/04/2023',
      '01/05/2023',
      '06/06/2023',
      '07/06/2023',
      '08/06/2023',
      '09/06/2023',
      '10/06/2023',
      '12/06/2023',
      '25/07/2023',
      '24/07/2023',
      '26/07/2023',
      '27/07/2023',
      '28/07/2023',
      '29/07/2023',
      '31/07/2023',
      '01/08/2023',
      '02/08/2023',
      '03/08/2023',
      '04/08/2023',
      '05/08/2023',
      '15/08/2023',
      '23/12/2023',
      '26/12/2023',
      '27/12/2023',
      '28/12/2023',
      '29/12/2023',
      '30/12/2023',
    ];
    const $select = $('#experience_type');
    if (!$select) return;

    const params = new URLSearchParams(window.location.search);

    if (window.location.search.indexOf('experience-type') > -1) {
      const val = decodeURIComponent(window.location.search.split('=')[1]);
      $select.value = val;
      if(typeof wineturism_form !== 'undefined'){
        wineturism_form.setup();
      }
    }


	const $dateinput = $('#date');
    // kendo.ui.DatePicker for jQuery
	const datepicker = new Datepicker($dateinput, {
      language: document.documentElement.lang,
      minDate: Date.now(),
      maxDate: '01/01/2024',
      format: 'dd/mm/yyyy'
    });

    $select.addEventListener('change', updatePicker);
    updatePicker();

    function updatePicker() {
      datepicker.setOptions({
          format: 'dd/mm/yyyy'
      });
      if ($select.value.indexOf('Wine Bar') > -1) {
        datepicker.setOptions({
          daysOfWeekDisabled: [0],
          datesDisabled: disabled,
        });

      } else {
        datepicker.setOptions({
          daysOfWeekDisabled: [0,1],
          datesDisabled: disabledMondays,
        });
        
        const enable = [
      '11/10/2022'];
      }
    }
  }

  // arrow-scroll
  // =====================================================

  function arrowScroll() {
    const arrow = document.getElementById('arrow-scroll');

    if (!arrow) return;

    arrow.addEventListener(
      'click',
      () => {
        if (document.querySelector('#after-header')) {
          document.querySelector('#after-header').scrollIntoView({
            behavior: 'smooth',
          });
        }
      },
      false
    );
  }

  // grid-horizontal-scroll
  // =====================================================

  function gridHorizontalScroll($el) {
    const $prev = $('.js-slider_prev', $el);
    const $next = $('.js-slider_next', $el);
    const $slider = $('.js-slider_slider', $el);

    if (!$slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    $slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - $slider.offsetLeft;
      scrollLeft = $slider.scrollLeft;
    });
    $slider.addEventListener('mouseleave', () => {
      isDown = false;
      $slider.classList.remove('active');
    });
    $slider.addEventListener('mouseup', () => {
      isDown = false;
      $slider.classList.remove('active');
    });
    $slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      $slider.classList.add('active');
      // moved = true;
      e.preventDefault();
      const x = e.pageX - $slider.offsetLeft;
      const walk = (x - startX) * 1.3;
      $slider.scrollLeft = scrollLeft - walk;
    });

    if ($prev && $next) {
      $prev.addEventListener('click', () => {
        $slider.scrollLeft -= 400;
      });

      $next.addEventListener('click', () => {
        $slider.scrollLeft += 400;
      });
    }
  }

  // popup
  // =====================================================

  function popup() {
    const OPEN = 'is-open';
    const $el = $('.js-popup');

    if (!$el || getCookie('popupClosed') === 'true') return;

    const $close = $('.js-popup_close', $el);
    const $link = $('.js-popup_link', $el);

    setTimeout(() => {
      $el.classList.add(OPEN);
    }, 5000);

    $close.addEventListener('click', close);
    window.addEventListener('keydown', ({ key }) => {
      if (key === 'Escape') close();
    });

    $link.addEventListener('click', (event) => {
      event.preventDefault();
      setCookie('popupClosed', 'true', 0.125);
      window.location = $link.getAttribute('href');
    });

    function close() {
      if ($el.classList.contains(OPEN)) {
        setCookie('popupClosed', 'true', 0.125);
        $el.classList.remove(OPEN);
      }
    }
  }

  // contact
  // =====================================================

  function contact() {
    const $select = $('#contact-type');
    if (!$select) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get('contact-type')) {
      $select.value = params.get('contact-type');
    }
  }

  // login
  // =====================================================

  function login($el) {
    const $loginForm = $('.js-login_loginForm', $el);
    const $recoverBtn = $('.js-login_recoverBtn', $el);
    const $recoverForm = $('.js-login_recoverForm', $el);
    const $loginBtn = $('.js-login_loginBtn', $el);
    const $confirm = $('.js-login_recoverSuccessConfirm', $el);
    const $success = $('.js-login_recoverSuccess', $el);

    if (window.location.hash === '#RecoverPasswordForm') {
      $recoverForm.classList.remove('hide');
      $loginForm.classList.add('hide');
    }

    if ($confirm) {
      $success.setAttribute('style', 'display: block');
    }

    $recoverBtn.addEventListener('click', (e) => {
      e.preventDefault();
      $recoverForm.classList.remove('hide');
      $loginForm.classList.add('hide');
      window.location.hash = '#RecoverPasswordForm';
    });

    $loginBtn.addEventListener('click', (e) => {
      e.preventDefault();
      $recoverForm.classList.add('hide');
      $loginForm.classList.remove('hide');
      window.location.hash = '';
    });
  }

  // cartIcon
  // =====================================================

  function cartIcon() {
    const $icon = document.getElementById('shop-icon-container');
    const $count = document.getElementById('cart-count');

    const event = new Event('requesttoopencart', { bubbles: true });
    $icon.addEventListener('click', () => {
      $icon.dispatchEvent(event);
    });

    function update() {
      fetch('/cart.js')
        .then((data) => data.json())
        .then((data) => {
          render(data.item_count);
        });
    }

    function render(count) {
      $count.innerHTML = count > 0 ? `(${count})` : '';
    }

    return { update, render };
  }

  // cart
  // =====================================================

  function cart(cartIcon) {
    const HIDDEN = 'hide';
    let loadingCart;
    const qtys = {};

    const $body = document.body;
    const $el = $('.js-cart');
    const $close = $('.js-cart_close', $el);
    const $empty = $('.js-cart_empty', $el);
    const $form = $('.js-cart_form', $el);
    const $overlay = $('.js-cart_overlay', $el);
    const $ageCheck = $('.js-cart_ageCheck', $el);
    const $giftCheck = $('.js-cart_giftCheck', $el);
    const $giftWrap = $('.js-cart_giftWrap', $el);
    const $giftText = $('.js-cart_giftText', $el);
    const $formError = $('.js-cart_error', $el);

    const $price = $('.js-cart_price', $el);
    const $list = $('.js-cart_list', $el);

    $close.addEventListener('click', closeCart);
    $overlay.addEventListener('click', closeCart);
    $form.addEventListener('submit', handleSubmit);
    $ageCheck.addEventListener('change', handleAgecheck);
    $giftCheck.addEventListener('change', handleGift);
    document.addEventListener('requesttoopencart', openCart);

    const cartItemMaxQuantities = JSON.parse(
      document.getElementById('js-cart_qtys').innerHTML
    );

    if (window.location.search.indexOf('open-cart') > -1) {
      openCart();
    }

    // Methods
    function handleSubmit(event) {
      if (!$ageCheck.checked) {
        event.preventDefault();
        $formError.classList.remove(HIDDEN);
        return;
      }

      $form.submit();
    }

    function handleAgecheck() {
      $formError.classList.toggle(HIDDEN, $ageCheck.checked);
    }

    function handleGift() {
      if ($giftCheck.checked) {
        $giftWrap.classList.remove(HIDDEN);
        $giftText.name = $giftText.dataset.name;
      } else {
        $giftWrap.classList.add(HIDDEN);
        $giftText.name = '';
      }
    }

    function openCart() {
      populateCart(() => {
        $body.classList.add('floating-cart-active');
        $body.classList.remove('floating-cart-closing', 'floating-cart-closed');
      });
    }

    function closeCart() {
      $body.classList.remove('floating-cart-active');
      $body.classList.add('floating-cart-closing');

      setTimeout(() => {
        $body.classList.remove('floating-cart-closing');
        $body.classList.add('floating-cart-closed');
      }, 450);
    }

    function populateCart(cb = () => {}) {
      if (loadingCart) return;

      loadingCart = true;
      fetch('/cart.js')
        .then((response) => response.json())
        .then((data) => {
          loadingCart = false;
          updateCartUi(data);
          cb();
        });
    }

    function updateCart(id, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ id, quantity }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((data) => data.json())
        .then((data) => updateCartUi(data, id, quantity));
    }

    function updatePrice({ items }) {
      const total = items.reduce((acc, item) => {
        return (acc += getProductPrice(item));
      }, 0);
      $price.innerHTML = Shopify.formatMoney(total, moneyFormat);
      // REDEGAL MDMS-13
       update_text_free_shipping(total);
      // REDEGAL 
    }

    function updateCartUi(data, id = null, quantity = null) {
      // console.log(data);

      if (data.items.length && id && quantity) {
        if (quantity <= 0) {
          qtys[id].destroy();
          const $item = $(`#${id}`);
          $item.parentNode.removeChild($item);
        }
      } else if (data.items.length) {
        $list.innerHTML = '';
        data.items.forEach((item) => {
          createCartItem(item);
        });
      } else {
        $list.innerHTML = '';
      }
      $empty.classList.toggle(HIDDEN, data.items.length);
      $form.classList.toggle(HIDDEN, !data.items.length);
      cartIcon.render(data.item_count);
      updatePrice(data);
    }

    function createCartItem(item) {
      const src = getSizedImageUrl(item.featured_image.url, '200x300');

      const title = item.title.split('|');
      const max = cartItemMaxQuantities[item.variant_id]
        ? cartItemMaxQuantities[item.variant_id]
        : 100;
      const el = document.createElement('div');
      el.id = item.key;

      const isBundle = item.product_type === 'Custom Bundle';
      const props = item.properties
        ? Object.keys(item.properties).reduce((acc, key) => {
            if (!key.startsWith('_')) {
              const str = item.properties[key].replace(/\[([^\]]+)\]/, '');
              acc.push(str.replace('<br>', ' '));
            }

            return acc;
          }, [])
        : [];

      el.innerHTML += `
        <div class="floatingCart_product">
          <div class="floatingCart_productData">
            <div class="floatingCart_productImg">
              ${
                src
                  ? `<img class="floatingCart_productImgImg" src="${src}" alt="">`
                  : `<div class="placeholder bg-white">
              <img class="placeholder_img" src="${placeholderUrl}" alt="">
            </div>`
              }
            </div>

            <div class="floatingCart_productInfo">
              <div class="floatingCart_productTitle">${title[0]}</div>
              <div class="floatingCart_productDesc">
                ${title.length >= 2 ? title[1] : ''}
                ${isBundle ? props.join('<br>') : ''}
              </div>
			  <div class="floatingCart_productMeta">
                <div
                  class="floatingCart_productQty qty js-qtySelector"
                  data-id="${item.variant_id}"
                  data-price="${getProductPrice(item)}"
                >
                  <button class="qty_btn js-qtySelector_less" type="button">
                    -
                  </button>
                  <input
                    class="qty_input js-qtySelector_input"
                    type="number"
                    id="updates_${item.id}"
                    name="updates[]"
                    min="0"
                    value="${item.quantity}"
                    max="${isBundle ? 1 : max}"
                  >
                  <button class="qty_btn js-qtySelector_more" type="button">
                    +
                  </button>
                </div>

                <div class="floatingCart_productPrice">
                  ${Shopify.formatMoney(getProductPrice(item), moneyFormat)}
                </div>
              </div>
            </div>
          </div>
        </div>
      `;

      $list.appendChild(el);
      qtys[item.key] = quantitySelector(
        $('.js-qtySelector', el),
        ({ quantity }) => {
          updateCart(item.key, quantity);
        }
      );

      if (isBundle) {
        qtys[item.key].setMax(1);
      }
    }

    function getProductPrice(product) {
      return product.properties && product.properties._bundle_price
        ? product.properties._bundle_price
        : product.final_line_price;
    }

    return { openCart };
  }

  // bb
  // =====================================================

  function bb() {
    const $el = $('.js-bb');

    if (!$el) return;

    const script = $('#bb-strings');
    const data = script ? JSON.parse(script.innerHTML) : null;

    if (!data) return;

    Object.keys(data).forEach((key) => {
      const $item = $(`.js-bb_${key}`);

      if ($item) {
        if (key.indexOf('img') > -1) {
          $item.style = `background-image: url(${data[key]})`;
        } else {
          $item.innerHTML = data[key];
        }
      }
    });
  }

  window.bundleBuilderFn = bb;

  document.addEventListener('DOMContentLoaded', () => {
    const cartInstace = cart(cartIcon());
    init();
    anchorpoints();
    product(cartInstace);
    search();
    arrowScroll();
    wineTourism();
    contact();
    popup();
    factory(gridHorizontalScroll, '.js-slider');
    factory(account, '.js-account');
    factory(acc, '.js-accordion');
    factory(addresses, '.js-addresses');
    factory(login, '.js-login');
  });
})();